import { render, staticRenderFns } from "./Uche.vue?vue&type=template&id=e618641e&scoped=true&"
import script from "./Uche.vue?vue&type=script&lang=js&"
export * from "./Uche.vue?vue&type=script&lang=js&"
import style0 from "./Uche.vue?vue&type=style&index=0&id=e618641e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e618641e",
  null
  
)

export default component.exports